import bandwidthMeasurementDeadLoad from '../assets/video_bandwidth_512kb.jpg';

type ChannelType = number; //0 | 1 | 2 | 3;

export class VideoControllerV1 {
  private path = '';
  private video: HTMLVideoElement;
  private videoVolume = 0.6;
  private codecString = 'video/mp4; codecs="avc1.640028, mp4a.40.2"';
  private mediaSource: MediaSource | null = null;
  private ws: WebSocket | null = null;
  private buffer?: SourceBuffer | null = null;
  private initBuffer = new Uint8Array();
  private activeConnectionTime = Date.now();
  private msgcnt = 0;
  private isPlayerStarted = false;
  private currentChannel: ChannelType = 1;
  private queue: Uint8Array[] = [];
  private isAutoChannel = true;
  private isInitBandWidth = false;
  private clientBandwidth = 0;
  private skiptoChannel = 0;
  private bandwidthDownloadSize = [400, 200, 80, 40];
  private bandWidthImageUrl = bandwidthMeasurementDeadLoad;
  private latency: number = 0;
  private channelChangeTime = Date.now();
  private channelUptimer: number | null = null;
  private isChannelChanging = false;
  private latencyUpdatedTime = Date.now();
  private isChannelGoingDown = false;
  private videoWaitingTimer = null;
  private reconnectingTimer: null | number = null;
  private pingCounter = 0;
  private pingReturnCounter = 0;
  private pingTimer: number | null = null;
  private pingTimerTimeout: null | number = null;
  private pingDowngradeCount = 0;
  private isVideoStopped = false;
  private isVideoResumeCount = 0;
  private isVideoPausedinGame = false;
  private isStageIntraction = false;
  private isVideoPlaybackStarted = false;
  private playbackStartTime: number | null = null;
  private videoRestrictToChannel = 0;
  private pingPongArray: number[] = [];
  private latencyArray: number[] = [];
  private pingPongDelayCheckForUpgrade = 300;
  private lowLatencyBufferCheckForUpgrade = 1;
  private isBandWidthDowngradedRecently = false;
  private isBandWidthDowngradedTimeout = 10 * 1000;
  private isMobile = false;
  private isVideoStoppedOnMinimize = false;
  private pingPongDelay: number | null = null;
  private maxQualityBasedOnBandwidth = 0;
  private playerSessionStartTime: number = Date.now();
  private playerSessionTime?: number;
  private _isVideoSessionStarted = false;
  private videoSessionStartTime: number = Date.now();
  private videoSessionTime: number = 0;
  private videoPlayStartTime?: number;
  private videoPlayTime: number = 0;
  private _isVideoPlaying = false;
  private videoSessionData = '0 | 0';
  // private uiStatsUpdatedTime?: number;
  private worker: null = null;
  private isVideoStarted?: boolean;
  private classicViewSwitcher?: (on: boolean) => void;
  private latencyListeners: Array<(latency: number) => void> = [];
  private latencyIntervalRef: number | null = null;

  constructor() {
    this.video = document.getElementById('video') as HTMLVideoElement;
    this.videoSessionStartTime = this.playerSessionStartTime = Date.now();
    this._isVideoSessionStarted = true;
  }

  private onStageTouch(): void {
    if (this.video) {
      this.isStageIntraction = true;
      if (this.video.muted && this.videoVolume > 0) {
        this.video.muted = false;
      }
      if (this.video.paused && !this.isVideoPlaying() && this.isInitBandWidth) {
        if (this.video.seekable.length > 0) {
          if (this.video.seekable.end(0) >= 1.5 && !this.isVideoPausedinGame) {
            this.playVideo();
          }
        }
      }
    }
  }

  public onVolumeChange(volume: number): void {
    this.videoVolume = volume;
    if (this.video) {
      this.video.volume = this.videoVolume;
      this.video.muted = !this.isStageIntraction || this.videoVolume <= 0;
    }
  }

  public onChannelChanged(channel: ChannelType | 'auto'): void {
    if (this.isPlayerStarted) {
      if (channel == 0) {
        if (this.currentChannel != 0) this.onChannel1Selected();
        this.isAutoChannel = false;
      } else if (channel == 1) {
        if (this.currentChannel != 1) this.onChannel2Selected();
        this.isAutoChannel = false;
      } else if (channel == 2) {
        if (this.currentChannel != 2) this.onChannel3Selected();
        this.isAutoChannel = false;
      } else if (channel == 3) {
        if (this.currentChannel != 3) this.onChannel4Selected();
        this.isAutoChannel = false;
      } else if (channel == 'auto') {
        this.onAutoChannelSelected();
        this.isAutoChannel = true;
      }
    } else {
      if (channel == 'auto') {
        this.isAutoChannel = true;
      } else {
        this.isAutoChannel = false;
        this.currentChannel = channel;
      }
    }
  }

  public addLatencyListener(listener: (latency: number) => void): void {
    this.latencyListeners.push(listener);
  }

  private onChannel1Selected(): void {
    this.currentChannel = 0;
    this.ShiftChannel();
  }
  private onChannel2Selected(): void {
    this.currentChannel = 1;
    this.ShiftChannel();
  }
  private onChannel3Selected(): void {
    this.currentChannel = 2;
    this.ShiftChannel();
  }
  private onChannel4Selected(): void {
    this.currentChannel = 3;
    this.ShiftChannel();
  }
  private onAutoChannelSelected(): void {
    this.isAutoChannel = true;
  }

  public connectSocket(): void {
    if (this.isVideoPausedinGame) {
      if (!this.videoSessionStartTime) {
        this.videoSessionStartTime = Date.now();
      } else {
        this.videoSessionStartTime = Date.now() - this.videoSessionTime * 1000;
      }
      this._isVideoSessionStarted = true;
      this.getVideoPlayTime();
      this.isVideoPausedinGame = false;
      this.resetplayer();
      if (this.isAutoChannel) {
        this.calculateClientBandwidth();
      } else {
        this.initWebsocketPlayer();
      }
    }
  }

  public closeSocket(): void {
    if (this.isVideoPausedinGame == false) {
      if (this._isVideoPlaying == true) {
        this.getVideoPlayTime();
        this._isVideoPlaying = false;
        this._isVideoSessionStarted = false;
      }
      this.isVideoPausedinGame = true;
      if (this.video) {
        this.video.pause();
      }
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
    }
  }

  public ngAfterViewInit = this.init;
  public init(path: string): void {
    this.video.controls = false;
    this.video.muted = true;
    this.video.hidden = false;

    if (path) {
      this.path = path;
      this.calculateClientBandwidth();
      this.channelUptimer = window.setInterval(
        () => {
          this.checkForChannelUp();
        },
        60 * 1000 * 1
      );
    }
    this.addVideoEventListeners();
    this.updateAndNotifyLatency();
  }

  private checkForChannelUp(): void {
    if (this.isAutoChannel) {
      if (
        this.currentChannel > this.maxQualityBasedOnBandwidth &&
        !this.isChannelChanging &&
        Date.now() - this.activeConnectionTime < 10000 &&
        this.currentChannel > this.videoRestrictToChannel
      ) {
        this.calculateUpBandwidth();
      }
    }
  }

  private calculateUpBandwidth(): void {
    const channel = this.getChannelForUpgrade();
    const curTime = Date.now();
    const delay = curTime - this.channelChangeTime;
    if (channel && this.currentChannel > channel && delay > 2 * 60 * 1000) {
      this.currentChannel = channel;
      this.ShiftChannel();
    }
  }

  private updateAndNotifyLatency(): void {
    // Update stream latency every 3 seconds.
    if (this.latencyIntervalRef) {
      clearInterval(this.latencyIntervalRef);
      this.latencyIntervalRef = null;
    }
    this.latencyIntervalRef = window.setInterval(() => {
      if (this.video.seekable.length > 0 && this._isVideoPlaying === true) {
        this.latency = this.video.seekable?.end(0) - this.video.currentTime;
        this.latencyListeners.forEach((listener) => listener(parseFloat((this.latency * 1000).toFixed(2))));
      }
    }, 3000);
  }

  private getChannelForUpgrade(): ChannelType | undefined {
    const checkDelayIndex = this.pingPongArray.findIndex((number) => {
      return number > this.pingPongDelayCheckForUpgrade;
    });
    const checkLowBufferIndex = this.latencyArray.findIndex((number) => {
      return number < this.lowLatencyBufferCheckForUpgrade;
    });
    this.pingPongArray = [];
    this.latencyArray = [];
    if (checkDelayIndex < 0 && checkLowBufferIndex < 0 && this.currentChannel > this.maxQualityBasedOnBandwidth) {
      return (this.currentChannel - 1) as ChannelType;
    }
  }

  private addVideoEventListeners(): void {
    if (!this.video) return;

    let visibilityChange: string | null = null;
    if (typeof document.hidden !== 'undefined') {
      visibilityChange = 'visibilitychange';
    } else if ('msHidden' in document && typeof document['msHidden'] !== 'undefined') {
      visibilityChange = 'msvisibilitychange';
    } else if ('webkitHidden' in document && typeof document['webkitHidden'] !== 'undefined') {
      visibilityChange = 'webkitvisibilitychange';
    }
    if (visibilityChange) {
      document.addEventListener(visibilityChange, this.handleVisibilityChange.bind(this));
    }

    this.video.addEventListener('waiting', () => {
      if (!this.video || this.isVideoPausedinGame) return;
      this.latency = this.video.seekable.end(0) - this.video.currentTime;

      if (this._isVideoPlaying == true) {
        this.getVideoPlayTime();
        this._isVideoPlaying = false;
      }
    });

    this.video.addEventListener('playing', () => {
      if (!this.video || this.isVideoPausedinGame) return;
      this.latency = this.video.seekable.end(0) - this.video.currentTime;
      this._isVideoPlaying = true;
      if (!this.videoPlayStartTime) {
        this.videoPlayStartTime = Date.now();
      } else {
        this.videoPlayStartTime = Date.now() - this.videoPlayTime * 1000;
      }
    });

    window.addEventListener('beforeunload', () => {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
    });

    window.addEventListener('mousedown', () => {
      this.onStageTouch();
    });
    window.addEventListener('touchstart', () => {
      this.onStageTouch();
    }); // for mobile
  }

  private handleVisibilityChange(): void {
    if (!document.hidden && !this.isVideoPausedinGame) {
      if (this.isMobile && this.isVideoStoppedOnMinimize) {
        this.startVideoOnMaxmize();
      }
      if (this.video.currentTime > 20) {
        setTimeout(() => {
          if (!this.isVideoPlaying()) {
            if (this.ws) {
              this.ws.close();
            }
            this.resetplayer();
            this.calculateClientBandwidth();
          }
        }, 4000);
      }
    } else if (document.hidden && !this.isVideoPausedinGame) {
      if (this.isMobile && !this.isVideoPausedinGame) {
        this.stopVideoOnMinimize();
      }
    }
  }

  private stopVideoOnMinimize(): void {
    if (this.video) {
      this.video.pause();
    }
    this.resetplayer();
    this.isVideoStoppedOnMinimize = true;
  }

  private startVideoOnMaxmize(): void {
    this.initWebsocketPlayer();
    this.isVideoStoppedOnMinimize = false;
  }

  private getVideoPlayTime(): string {
    // this.uiStatsUpdatedTime = Date.now();
    this.playerSessionTime = Math.round(((Date.now() - this.playerSessionStartTime) / 1000) * 100) / 100;
    if (this._isVideoSessionStarted) {
      this.videoSessionTime = Math.round(((Date.now() - this.videoSessionStartTime) / 1000) * 100) / 100;
    }
    if (this._isVideoPlaying && this.videoPlayStartTime) {
      this.videoPlayTime = Math.round(((Date.now() - this.videoPlayStartTime) / 1000) * 100) / 100;
    }
    this.videoSessionData =
      this.playerSessionTime +
      ' | ' +
      this.videoSessionTime +
      ' | ' +
      this.videoPlayTime +
      ' | ' +
      (this.videoSessionTime - this.videoPlayTime).toFixed(2);
    return this.videoSessionData;
  }

  private ShiftChannel(): void {
    if (!this.isChannelChanging) {
      if (this.worker == null) {
        if (this.videoRestrictToChannel > 0) {
          if (this.videoRestrictToChannel > this.currentChannel) {
            this.currentChannel = this.videoRestrictToChannel;
          }
        }
        if (this.ws?.readyState == WebSocket.OPEN) {
          this.ws.send('qcreq' + this.currentChannel);
          this.ws.send('quality' + this.currentChannel);
        }
        if (this.channelUptimer) {
          clearInterval(this.channelUptimer);
          this.channelUptimer = null;
          this.channelUptimer = window.setInterval(
            () => {
              this.checkForChannelUp();
            },
            60 * 1000 * 1
          );
        }
      }

      this.isChannelChanging = true;
    }
  }

  private initWebsocketPlayer(): void {
    if ('MediaSource' in window && MediaSource.isTypeSupported(this.codecString)) {
      this.mediaSource = new MediaSource();
      this.video.src = this.createObjectURL(this.mediaSource);
      this.mediaSource.addEventListener('sourceopen', this.sourceBufferHandle.bind(this));
      this.mediaSource.addEventListener('sourceended', this.onSourceEnded.bind(this));
    } else {
      console.error('Unsupported MIME type or codec: ', this.codecString);
    }

    if (this.pingTimer) {
      clearInterval(this.pingTimer);
      this.pingTimer = null;
    }
    this.pingTimer = window.setInterval(() => {
      if (this.isVideoPausedinGame || !this.isVideoStarted) return;
      const currentTime = Date.now();
      const msg = {
        cmd: 'ping',
        counter: this.pingCounter,
        clientTime: currentTime,
      };

      if (this.ws) {
        if (this.ws.readyState == 1) {
          this.ws.send(JSON.stringify(msg));
        } else if (this.ws.readyState > 1) {
          // this.classicViewSwitcher?.(true);
          this.resetplayer();
          this.calculateClientBandwidth();
        }
      } else {
        // this.classicViewSwitcher?.(true);
        this.resetplayer();
        this.calculateClientBandwidth();
      }

      if (this.pingTimerTimeout) {
        clearTimeout(this.pingTimerTimeout);
        this.pingTimerTimeout = null;
      }
      this.pingTimerTimeout = window.setTimeout((): void => {
        if (this.pingCounter != this.pingReturnCounter && !this.isBandWidthDowngradedRecently) {
          this.isBandWidthDowngradedRecently = true;
          setTimeout(() => {
            this.isBandWidthDowngradedRecently = false;
          }, this.isBandWidthDowngradedTimeout);
          this.pingCounter = this.pingCounter + 1;
          this.pingDowngradeCount++;
          if (this.pingCounter > 2 && this.msgcnt > 1) {
            if (this.currentChannel == 3) {
              this.isVideoResumeCount = 0;
              // this.classicViewSwitcher?.(true);
              this.video.pause();
              this.latencyUpdatedTime = Date.now();
              window.parent.window.postMessage({ type: 'notifyVideoLatency', latency: 2500 }, '*');
              this.resetplayer();
              this.initWebsocketPlayer();
            } else {
              this.video.hidden = true;
              this.isChannelGoingDown = true;
              this.isChannelChanging = true;
              setTimeout(() => {
                this.checkForBandwidthToDowngrade();
              }, 2000);
            }
          }
        } else {
          this.pingDowngradeCount = 0;
          this.pingCounter = this.pingCounter + 1;
          this.isVideoResumeCount++;
          if (this.isVideoResumeCount > 2 && this.isVideoStopped) {
            this.isVideoStopped = false;
            this.isVideoResumeCount = 0;
            this.playVideo();
          }
        }
      }, 2000);
    }, 5000);
  }

  private sourceBufferHandle(): void {
    if (!this.ws) {
      this.initWS();
    }
    this.buffer = this.mediaSource?.addSourceBuffer(this.codecString);
    if (!this.buffer) return;
    this.buffer.mode = 'sequence';

    this.buffer.addEventListener('updateend', () => {
      this.updateBuffer();
      if (this.video.seekable.length > 0) {
        if (this.video.seekable.end(0) >= 5.0 && this.video.currentTime === 0) {
          this.video.currentTime = this.video.seekable.end(0) - 1;
        }
      }
      if (!this.isVideoPlaying()) {
        if (this.video.seekable.length > 0) {
          if (this.video.seekable.end(0) >= 1.5) {
            if (this.video.paused) {
              this.playVideo();
              if (this.video.seekable.end(0) <= 3) {
                this.latency = this.video.seekable.end(0) - this.video.currentTime;
              }
            }
          }
          if (!this.isVideoStarted) {
            this.isVideoStarted = true;
            window.parent.window.postMessage({ type: 'notifyVideoLoaded' }, '*');
          }
          if (this.videoVolume > 0 && this.isStageIntraction) {
            this.video.muted = false;
          }
        }
      }
    });
    this.isPlayerStarted = true;
  }

  private initWS(): void {
    try {
      if (this.isVideoPausedinGame) return;

      if (this.reconnectingTimer) {
        clearInterval(this.reconnectingTimer);
        this.reconnectingTimer = null;
      }
      this.ws = new WebSocket(this.path);
      this.ws.binaryType = 'arraybuffer';
      // $('#videoavailable').hide();
      this.ws.onopen = (): void => {
        // console.info('WebSocket connection initialized in channel', this.currentChannel, Date.now());
      };
      this.ws.addEventListener('message', this.onWebSocketMessage.bind(this));
      this.ws.onclose = (event): void => {
        if (this.isVideoPausedinGame) return;
        const currentTimeDiff = Date.now() - this.activeConnectionTime;
        if (!this.ws && currentTimeDiff > 30000) {
          this.resetplayer();
          this.calculateClientBandwidth();
        }
        if (!this.isVideoStarted) {
          this.ws = null;
          if (this.channelUptimer) {
            clearInterval(this.channelUptimer);
            this.channelUptimer = null;
          }
          // window.parent.window.postMessage({ type: 'notifyClassicViewChange', visible: true }, '*');
          if (this.reconnectingTimer) {
            clearInterval(this.reconnectingTimer);
            this.reconnectingTimer = null;
          }
          this.reconnectingTimer = window.setInterval(
            () => {
              if (!this.ws) this.initWS();
            },
            30 * 1000 * 1
          );
        }
      };
      this.ws.onerror = (e): void => {
        // console.log('ws error', e);
      };
    } catch (e) {
      if (this.channelUptimer) {
        clearInterval(this.channelUptimer);
        this.channelUptimer = null;
      }
      // this.classicViewSwitcher?.(true);
      if (this.reconnectingTimer) {
        clearInterval(this.reconnectingTimer);
        this.reconnectingTimer = null;
      }
      this.reconnectingTimer = window.setInterval(
        () => {
          if (!this.ws) this.initWS();
        },
        30 * 1000 * 1
      );
    }
  }

  private onWebSocketMessage(event: MessageEvent): void {
    if (typeof event.data === 'object') {
      if (this.isVideoStopped) {
        return;
      }

      this.activeConnectionTime = Date.now();

      if (this.isChannelGoingDown && this.isVideoPausedinGame && !this.buffer) {
        return;
      }

      const bufferdata = new Uint8Array(event.data);
      const rule = bufferdata[0] == 0 && bufferdata[1] == 0 && bufferdata[2] == 0;

      if (this.msgcnt == 0 && rule) {
        this.initBuffer = new Uint8Array(bufferdata);
        if (this.buffer) {
          this.buffer.abort();
          if (!this.buffer.updating) {
            this.buffer.appendBuffer(this.initBuffer);
          } else {
            this.queue.push(this.initBuffer);
          }
        }
        this.playbackStartTime = Date.now();
        this.msgcnt++;
      } else if (this.msgcnt == 1 && rule && this.buffer) {
        if (!this.buffer.updating) {
          this.buffer.appendBuffer(bufferdata);
        } else {
          this.queue.push(bufferdata);
        }
        this.msgcnt++;
      } else if (this.msgcnt > 1 && this.buffer) {
        if (this.buffer.updating || this.queue.length > 0) {
          this.queue.push(bufferdata);
          this.video.hidden = false;
        } else {
          this.buffer.appendBuffer(bufferdata);
          if (this.video.seekable.length > 0) {
            if (this.video.seekable.end(0) >= 1.5 && !this.isVideoPlaying()) {
              if (this.video.paused) {
                this.playVideo();
                if (this.video.seekable.end(0) <= 3) {
                  this.latency = this.video.seekable.end(0) - this.video.currentTime;
                }
              }
              if (!this.isVideoStarted) {
                this.isVideoStarted = true;
                window.parent.window.postMessage({ type: 'notifyVideoLoaded' }, '*');
              }
              this.video.hidden = false;
              if (this.videoVolume > 0 && this.isStageIntraction && this.video.muted) {
                this.video.muted = false;
              }
            }
          }
          if (this.isVideoPlaybackStarted == false && this.isVideoPlaying()) {
            this.isVideoPlaybackStarted = true;
          } else if (
            this.playbackStartTime &&
            !this.isVideoPlaying() &&
            !this.isVideoPlaybackStarted &&
            Date.now() - this.playbackStartTime > 10000
          ) {
            if (this.videoRestrictToChannel > 0) {
              if (this.videoRestrictToChannel > this.currentChannel) {
                this.currentChannel = this.videoRestrictToChannel;
              }
            }
            this.resetplayer();
            this.initWebsocketPlayer();
            this.isInitBandWidth = true;
            this.isVideoPlaybackStarted = true;
            setTimeout(() => {
              this.isVideoPlaybackStarted = false;
            }, 5000);
          }
        }
        this.msgcnt++;
      }
    } else {
      const cmd = JSON.parse(event.data);
      switch (cmd.cmd) {
        case 'reset':
          this.currentChannel = cmd.ch;
          this.isChannelChanging = false;
          this.isChannelGoingDown = false;
          this.video.pause();
          this.msgcnt = 0;
          this.classicViewSwitcher?.(this.currentChannel == 3);
          break;
        case 'conn':
        case 'connected':
          if (this.ws) {
            if (this.videoRestrictToChannel > 0) {
              if (this.videoRestrictToChannel > this.currentChannel) {
                this.currentChannel = this.videoRestrictToChannel;
              }
            }

            if (this.ws.readyState == WebSocket.OPEN) {
              this.ws.send('iq' + this.currentChannel);
              this.ws.send('quality' + this.currentChannel);
            }
          } else {
            this.initWS();
          }
          break;
        case 'ts':
          break;
        case 'pong':
          this.pingReturnCounter = cmd.counter;
          this.pingPongDelay = Math.round(Date.now() - cmd.clientTime);
          this.pingPongArray.push(this.pingPongDelay);
          if (this.pingPongArray.length > 10) {
            this.pingPongArray.shift();
          }
          this.latencyArray.push(this.latency);
          if (this.latencyArray.length > 10) {
            this.latencyArray.shift();
          }
          break;
      }
    }
  }

  private playVideo(): void {
    if (this.video) {
      this.video.play();
    }
  }

  private updateBuffer = (): void => {
    if (!this.buffer) return;
    this.isPlayerStarted = true;
    this.videoWaitingTimer = null;
    if (this.queue.length > 0 && !this.buffer.updating) {
      const nextBufferItem = this.queue.shift();
      if (nextBufferItem) {
        this.buffer.appendBuffer(nextBufferItem);
      }
    }

    if (this.video.seekable.length > 0 && this.video.currentTime > 0) {
      this.latency = this.video.seekable.end(0) - this.video.currentTime;

      if (this.latency > 3.5) {
        this.video.currentTime = this.video.seekable.end(0) - 1.75;
        this.latency = 0;
      }

      if (Date.now() - this.latencyUpdatedTime > 30 * 1000) {
        this.latencyUpdatedTime = Date.now();
        if (this.latency > 0) {
          window.parent.window.postMessage({ type: 'notifyVideoLatency', latency: (this.latency + 0.75) * 1000 }, '*');
        } else {
          window.parent.window.postMessage({ type: 'notifyVideoLatency', latency: 750 }, '*');
        }
      }
    } else if (this.video.seekable.length > 0 && this.video.readyState > 0 && !this.isVideoPlaying()) {
      if (this.video.seekable.end(0) > 2.5) {
        this.video.pause();
        this.video.currentTime = this.video.seekable.end(0) - 1.0;
      }
    }
  };

  private calculateClientBandwidth(): void {
    const imageUrl = this.bandWidthImageUrl + '?n=' + Math.random();
    let endTime: number;
    const downloadSize = 0.5 * 1024 * 1024;

    const xhr = new XMLHttpRequest();

    xhr.open('GET', imageUrl, true);
    xhr.responseType = 'arraybuffer';
    xhr.timeout = 4000;

    xhr.ontimeout = (): void => {
      if (this.isInitBandWidth) return;
      endTime = new Date().getTime();
      this.currentChannel = 2;
      this.initWebsocketPlayer();
      this.isInitBandWidth = true;
      this.maxQualityBasedOnBandwidth = this.currentChannel;
    };

    xhr.onloadend = (): void => {
      if (xhr.status == 200) {
        if (this.isInitBandWidth) return;
        endTime = new Date().getTime();
        const duration = (endTime - startTime) / 1000;
        const speedBps = Math.round(downloadSize / duration);
        this.clientBandwidth = speedBps / 1024;
        this.skiptoChannel = this.getChannel();
        this.currentChannel = this.skiptoChannel;
        this.initWebsocketPlayer();
        this.isInitBandWidth = true;
        this.maxQualityBasedOnBandwidth = this.currentChannel;
      } else {
        if (this.isInitBandWidth) return;
        this.currentChannel = 2;
        this.initWebsocketPlayer();
        this.isInitBandWidth = true;
        this.maxQualityBasedOnBandwidth = this.currentChannel;
      }
    };
    xhr.onerror = (): void => {
      this.currentChannel = 2;
      this.initWebsocketPlayer();
      this.isInitBandWidth = true;
      this.maxQualityBasedOnBandwidth = this.currentChannel;
    };
    xhr.send();
    const startTime: number = Date.now();
  }

  private resetplayer = (): void => {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    if (this._isVideoPlaying == true) {
      this.getVideoPlayTime();
      this._isVideoPlaying = false;
    }
    this.pingPongDelay = null;
    this.clearEventListeners();
    this.buffer = null;
    this.initBuffer = new Uint8Array();
    this.activeConnectionTime = Date.now();
    // this.isLowBandWidth = false;
    this.isPlayerStarted = false;
    this.queue = [];
    // this.bandwidthArray = [];
    this.isInitBandWidth = false;
    this.clientBandwidth = 0;
    // this.avgbandwidth = 0;
    // this.bandwidth = 0;
    this.latency = 0;
    // this.videoPauseCount = 0;
    this.channelChangeTime = Date.now();
    // this.videoPauseCountResetTime = Date.now();
    if (this.channelUptimer && this.worker == null) {
      clearInterval(this.channelUptimer);
      this.channelUptimer = null;
      this.channelUptimer = window.setInterval(
        () => {
          this.checkForChannelUp();
        },
        60 * 1000 * 1
      );
    }
    // this.bwPrintCounter = 0;
    this.isChannelChanging = false;
    this.latencyUpdatedTime = Date.now();
    window.parent.window.postMessage({ type: 'notifyVideoLatency', latency: 2500 }, '*');
    this.isChannelGoingDown = false;
    if (this.videoWaitingTimer) {
      clearTimeout(this.videoWaitingTimer);
      this.videoWaitingTimer = null;
    }

    if (this.reconnectingTimer) {
      clearInterval(this.reconnectingTimer);
      this.reconnectingTimer = null;
    }

    this.pingCounter = 0;
    this.pingReturnCounter = 0;
    this.pingDowngradeCount = 0;
    if (this.pingTimer) {
      clearInterval(this.pingTimer);
      this.pingTimer = null;
    }
    if (this.pingTimerTimeout) {
      clearTimeout(this.pingTimerTimeout);
      this.pingTimerTimeout = null;
    }

    this.isVideoPlaybackStarted = false;
    this.playbackStartTime = null;
    this.pingPongArray = [];
    this.latencyArray = [];
  };

  private clearEventListeners(): void {
    if (this.mediaSource) {
      this.mediaSource.removeEventListener('sourceopen', this.sourceBufferHandle.bind(this));
      this.mediaSource.removeEventListener('sourceended', this.onSourceEnded.bind(this));
    }
  }

  private checkForBandwidthToDowngrade(): void {
    let channel: number | undefined;
    if (this.currentChannel < 3) {
      channel = this.currentChannel + 1;
    }
    if (this.currentChannel != channel && channel != -1) {
      if (!this.isAutoChannel) {
        this.isAutoChannel = true;
        window.parent.window.postMessage({ type: 'LOW_BANDWIDTH' }, '*');
      }
      this.currentChannel = channel as ChannelType;
      this.resetplayer();
      this.initWebsocketPlayer();
      this.isChannelGoingDown = true;
      this.isChannelChanging = true;
    }
  }

  getChannel(): number {
    if (this.clientBandwidth > this.bandwidthDownloadSize[0]) {
      return 0;
    } else if (this.clientBandwidth > this.bandwidthDownloadSize[1]) {
      return 1;
    } else if (this.clientBandwidth > this.bandwidthDownloadSize[2]) {
      return 2;
    } else {
      return 3;
    }
  }

  private isVideoPlaying = (): boolean => {
    return this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2;
  };

  private createObjectURL(object: MediaSource): string {
    return window.URL ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
  }

  private onSourceEnded(): void {
    this.resetplayer();
    this.calculateClientBandwidth();
  }

  public setClassicViewSwitcher(switcher: (on: boolean) => void): void {
    this.classicViewSwitcher = switcher;
  }

  getChannelLimit(): number {
    return this.isAutoChannel ? this.maxQualityBasedOnBandwidth : this.getChannel();
  }
}
